module.exports = "../../static/img/asterisk-white.7d4ff1f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/asterisk-white.png
// module id = 78
// module chunks = 0